export default "__VITE_ASSET__DOoaGgGN__"